export const AR_BLOG_SLUGS = [
  'galataport-shore-excursion-guide',
  'best-halal-restaurants-istanbul',
  'istanbul-neighborhoods-guide',
  'bosphorus-cruise-complete-guide',
  'turkish-citizenship-by-investment-2026',
  'buying-property-istanbul-gulf-arab-guide',
  'first-time-visitor-guide-istanbul-gulf',
  'istanbul-in-ramadan-gcc-visitors-guide',
];

export const AR_PATHS = [
  '/',
  '/travel',
  '/real-estate',
  '/blog',
  '/faq',
  '/reviews',
  '/contact',
  '/tours/bosphorus-cruises',
  '/tours/food-culture-tours',
  '/tours/turkish-citizenship-investment',
  '/tours/real-estate-consulting',
  '/layover-tours-istanbul',
  '/layover-tours-istanbul/7-hours',
  '/layover-tours-istanbul/8-hours',
  '/layover-tours-istanbul/10-hours-plus',
  '/layover-tours-istanbul/istanbul-airport-ist',
  '/layover-tours-istanbul/sabiha-gokcen-saw',
  ...AR_BLOG_SLUGS.map(s => `/blog/${s}`),
];

const norm = (p) => (p || '/').replace(/\/$/, '') || '/';

export function hasArVersion(path) {
  return AR_PATHS.includes(norm(path));
}

export function isArPath(path) {
  return path === '/ar' || path === '/ar/' || path.startsWith('/ar/');
}

export function toArPath(path) {
  const p = norm(path);
  return p === '/' ? '/ar' : `/ar${p}`;
}

export function toEnPath(path) {
  const p = norm(path);
  if (p === '/ar') return '/';
  return p.startsWith('/ar/') ? p.slice(3) : p;
}

export function localizePath(path, language) {
  if (language !== 'ar' || !path || !path.startsWith('/')) return path;
  const hashIdx = path.indexOf('#');
  const base = hashIdx >= 0 ? path.slice(0, hashIdx) : path;
  const hash = hashIdx >= 0 ? path.slice(hashIdx) : '';
  return hasArVersion(base) ? toArPath(base) + hash : path;
}
